<template>
  <div>
    <!-- breadcrumb area end -->
    
     <div class="container" v-if="this.storeCustomer != undefined">
        <div class="row"><div class="col-24">Afspraak opmaken voor <strong>{{this.storeCustomer.FirstName}}  {{this.storeCustomer.LastName}}</strong></div></div>
    </div>

<div class="container">
  <category-list :categories= "subcategories" :products="products"></category-list>
</div>

    <div class="container" v-if="isSubCat">
      <div class="row">
             <div class="col-2"></div>
             <router-link :to="'/saloncategories'" class="product-link">
              <div class="product-btn" >
                      <a><i class="ion-arrow-left-c"  style="color:#111111"></i>Terug</a>
                    </div>
              </router-link>
        </div>

        <div class="row"><div class="col-24">&nbsp;</div></div>
        <div class="row"><div class="col-24"></div></div>
      </div>
    <div class="container">
       <router-link to="/salonselect" class="product-link"><div class="product-btn" style="color:#111111"><a><i></i>Kies een ander salon</a></div></router-link>
    </div>

    
<div class="container">
        <div class="row"><div class="col-24" style="color:#696969;text-align:center;position: absolute;bottom: 0;right: 50%;"><a target="_blank" style="color:#696969;font-size:small" href="https://www.posworld.be">Powered by Posworld</a></div></div>
</div>

  </div>
</template>

<script>
  import Vue from 'vue';
  import ProductList from '../../components/products/ProductList.vue';
  import CategoryList from '../../components/categories/CategoryList.vue';
  import myHttpApi from "../../api/myhttpapi";

  export default {
    name: 'home',
    components: {
      'product-list': ProductList,
      'category-list': CategoryList
    },
     data () {
      return {
        currentCat : {},
        storeCustomer : undefined,
        isSubCat : false,
        fullPage: false,
        isRoot : false,
        salonname : '',
        salonlocation : ''
      }
    },
    created () {
      document.title = "Reserveer online bij " + Vue.$storeSettings.StoreName
      this.salonname = Vue.$selectedStore.UserName
      this.salonlocation = Vue.$selectedStore.Location
      console.log (this.salonname)
    },
    methods: {
      navigate (item) {
        this.isSubCat = false;
        this.$router.push(item);
      },
      navigateBack () {
        this.$router.go(-1);
        this.isSubCat = false;
      }
    },
    computed: {
      subcategories () {
        var cats = this.$store.getters.allCategories;
        var id = this.$route.params['id'];
        if (cats == undefined) 
        {
          return [];
        }
        this.isSubCat = false;

        for (var i = 0; i < cats.length; i++) {
            var cat = cats[i];
            if (cat.CategoryID == id)
            {
                this.currentCat = cat;
                if (cat.SubCat == undefined) {return []}

                this.isSubCat = true;
                return cat.SubCat
            }
            else
            {
                if (cat.SubCat != undefined)
                {
                    for (var s = 0; s < cat.SubCat.length; s++) {
                        if (cat.SubCat[s].CategoryID == id)
                        {
                          this.currentCat = cat.SubCat[s];
                          this.isSubCat = true;
                          return cat.SubCat[s].SubCat
                        }
                    }
                }
            }
        }

        this.isSubCat = false;
        return this.$store.getters.allCategories;

      },
      products () {
        var cats = this.$store.getters.allCategories
        var id = this.$route.params['id']
        if (cats == undefined)  {return [];}

        for (var i = 0; i < cats.length; i++) {
            var cat = cats[i];
            if (cat.CategoryID == id)
            {
                return cats[i].Services
            }
            else
            {
                if (cat.SubCat != undefined)
                {
                    for (var s = 0; s < cat.SubCat.length; s++) {
                        if (cat.SubCat[s].CategoryID == id)
                        {
                          return cat.SubCat[s].Services
                        }
                    }
                }
            }
        }

        return [];
      }
    },
    watch: {
      '$route' (to, from) {
      
      }
    },
    mounted() {
      this.isSubCat = false;
      this.storeCustomer = Vue.$storeCustomer;
    },
   
  }
</script>



// WEBPACK FOOTER //
// src/pages/SingleSalon/SalonCategories.vue